<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Select v-model="search.bigPluginType" style="width: 150px;" placeholder="请选择插件分类" @on-change="loadData">
        <Option value="">全部</Option>
        <Option value="sdk">sdk</Option>
        <Option value="apk">apk</Option>
      </Select>
      <all-user ref="allUser" :type="'all'" style="margin-top:10px;" @usernameChange="usernameChange"></all-user>
    </div>
    <div class="select-box input_left">
      <Input v-model="search.pluginTitle" style="width:150px;" placeholder="请输入插件名称"/>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="search.pkgName" style="width:150px;" placeholder="请输入宿主包名" />
      <Select v-model="search.status" style="width: 150px;margin-left:25px;" placeholder="请选择审核状态">
        <Option value="">全部</Option>
        <Option :value="0">待审核</Option>
        <Option :value="1">审核通过</Option>
        <Option :value="2">审核驳回</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal :mask-closable="false"
           v-model="checkdata"
           title="审核驳回"
           :loading="loading"
           @on-cancel="cancelReason"
           @on-ok="editData()">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidate.reason" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
    <Modal :mask-closable="false"
           v-model="isShowInfo"
           :footer-hide="true"
           title="详情">
      <Form ref="formApkInfo" :model="formApkInfo" :label-width="120">
        <FormItem label="插件名称" prop="pluginTitle">
          <Input v-model="formApkInfo.pluginTitle" :disabled="editFlag" placeholder="" />
        </FormItem>
        <FormItem label="插件包名" prop="pluginCode">
          <Input v-model="formApkInfo.pluginCode" :disabled="editFlag" placeholder="" />
        </FormItem>
        <FormItem label="宿主包名" prop="pkgName">
          <Input v-model="formApkInfo.pkgName" :disabled="editFlag" placeholder="" />
        </FormItem>
        <FormItem label="指定渠道" prop="channelCode">
          <Input v-model="formApkInfo.channelCode" :disabled="editFlag" placeholder="" />
        </FormItem>
        <!-- <FormItem label="UUID" prop="uuid">
          <Input v-model="formApkInfo.uuid" :disabled="editFlag" placeholder="" />
        </FormItem>
        <FormItem label="资源ID" prop="resourceId">
          <Input v-model="formApkInfo.resourceId" :disabled="editFlag" placeholder="" />
        </FormItem> -->
        <FormItem label="更新说明" prop="remarks">
          <Input v-model="formApkInfo.remarks" :disabled="editFlag" maxlength="50" type="textarea" :rows="4" placeholder="" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import allUser from '@/components/global/allUser'
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'checkApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      isShowInfo: false,
      selectItems: [],
      sdkVersion: [],
      check: [
        { name: '待审核', val: 0 },
        { name: '审核通过', val: 1 },
        { name: '审核驳回', val: 2 }
      ],
      search: {
        // aduit_stats: 9
        bigPluginType: '',
        pluginTitle: '',
        pkgName: '',
        status: '',
        createBy: ''
        // pluginTitle: '测试'
      },
      formApkInfo: {},
      formValidate: {
        aduit_stats: '',
        reason: '',
        id: '',
        bigPluginType: ''
      },
      editFlag: true,
      ruleValidate: {
        reason: [
          { required: false, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 50, message: '最多输入50个字', trigger: 'blur' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '插件分类',
          key: 'bigPluginType',
          align: 'center',
          width: 90
        },
        {
          title: '插件名称',
          key: 'pluginTitle',
          width: 200,
          align: 'center'
        },
        {
          title: '审核状态',
          key: 'status',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let checked = ''
            this.check.forEach(n => {
              if (n.val === params.row.status) checked = n.name
            })
            let html = [
              h('span', checked)
            ]
            if (params.row.status === 2 && params.row.reason) {
              html.push(h('Tooltip', {
                props: {
                  placement: 'bottom',
                  content: params.row.reason
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-help-circle-outline'
                  },
                  style: {
                    color: '#f00'
                  }
                })
              ]))
            }
            return h('div', html)
          }
          // render: (h, params) => {
          //   let status = ''
          //   switch (params.row.status) {
          //     case 0:
          //       status = '待审核'
          //       break
          //     case 1:
          //       status = '审核通过'
          //       break
          //     case 2:
          //       status = '审核驳回'
          //       break
          //   }
          //   let html = [
          //     h('span', status)
          //   ]
          //   return html
          // }
        },
        {
          title: '插件包名',
          key: 'pluginCode',
          width: 150,
          align: 'center'
        },
        {
          title: '宿主包名',
          key: 'pkgName',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let status = ''
            if (params.row.pkgName.length > 0) {
              status = params.row.pkgName
            } else {
              status = '全部'
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '指定渠道',
          key: 'channelCode',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            if (params.row.channelCode.length > 0) {
              status = params.row.channelCode
            } else {
              status = '全部'
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        // {
        //   title: 'UUID',
        //   key: 'uuid',
        //   align: 'center',
        //   width: 150
        // },
        // {
        //   title: '资源ID',
        //   key: 'resourceId',
        //   align: 'center',
        //   width: 100
        // },
        {
          title: '更新说明',
          key: 'remarks',
          width: 130,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width: 200
        },
        {
          title: '审核时间',
          key: 'updateTime',
          align: 'center',
          width: 200
        },
        {
          title: '操作人',
          key: 'updateBy',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 230,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.isShowInfo = true
                    this.formApkInfo = params.row
                    this.formApkInfo.pkgName = params.row.pkgName.length === 0 ? '全部' : params.row.pkgName
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: (params.row.status === 1 || params.row.status === 2)
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editData(1, params.row)
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: (params.row.status === 1 || params.row.status === 2)
                },
                on: {
                  click: () => {
                    this.checkdata = true
                    this.formValidate.status = 2
                    this.formValidate.id = params.row.id
                    this.formValidate.bigPluginType = params.row.bigPluginType
                    // this.editData(2, params.row)
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb,
    allUser
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.search = {
        bigPluginType: '',
        pluginTitle: '',
        pkgName: '',
        status: '',
        createBy: ''
      }
      this.$refs.allUser.clear()
      this.loadData()
    },
    usernameChange (val) {
      this.search.createBy = val
      this.loadData()
    },
    // 加载tabs列表
    loadData () {
      https.request({
        method: 'get',
        // url: '/v1/check/app',
        url: '/extscreenapi/plugin/hili/esPluginVerify/list',
        params: {
          ...this.search,
          pageNo: this.current,
          pageSize: this.pageSize,
          column: 'createTime',
          order: 'desc'
        }
      }).then(res => {
        this.tableLoading = false
        // this.dataSource = res.result.records || []
        this.total = res.result.total
        // this.current = res.result.current
        // this.pageSize = res.result.pages
        // this.setData()
        // this.dataList = res.result.records || []
        this.getUserNameFun(res.result.records || [])
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.createBy)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (item.value === sItem.createBy) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
        this.dataSource = list
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      // this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    cancelReason () {
      this.$refs['formValidate'].resetFields()
    },
    editData (type = 1, row = {id: 0}) {
      let params = {
        status: type,
        id: row.id,
        bigPluginType: row.bigPluginType
      }
      if (this.formValidate.status === 2) {
        params.status = this.formValidate.status
        params.id = this.formValidate.id
        params.reason = this.formValidate.reason
        params.bigPluginType = this.formValidate.bigPluginType
      }
      https.request({
        method: 'post',
        url: 'extscreenapi/plugin/hili/esPluginVerify/verify',
        data: params
      }).then(res => {
        if (res.code === 500) {
          this.$Message.success(res.message)
          return
        }
        this.$Message.success('提交成功')
        this.$refs['formValidate'].resetFields()
        this.formValidate = {
          aduit_stats: '',
          reason: '',
          id: '',
          bigPluginType: ''
        }
        this.checkdata = false
        this.loadData()
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container{
  position: relative
}
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 67px;
    right: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:207px;
    // left:407px;
  }
  .input_left_two{
    left:380px;
    // left:580px;
  }
  .input_left_three{
    left:735px;
    // left:755px;
  }
</style>



// WEBPACK FOOTER //
// src/components/check/checkSdk.vue